import {FC} from 'react'

const Error500: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Системная ошибка</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Что-то пошло не так.
      </div>
    </>
  )
}

export {Error500}
